<template>
    <el-dialog
        title="选择店铺"
        :visible.sync="visible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose"
    >
        <div
            v-loading.fullscreen.lock="loading"
            element-loading-text="正在加载数据"
            element-loading-background="rgba(255, 255, 255, 0)"
        >
            <div class="mb20">
                <el-input
                    v-model="keyword"
                    placeholder="请输入竞争对手店铺内任意一条产品地址或旺旺ID"
                    style="width: 352px; margin-right: 10px"
                    size="medium"
                />
                <el-button type="primary" size="medium" @click="addShop">添加</el-button>
            </div>
            <el-table :data="shopList" stripe style="width: 100%" :header-cell-style="tableHeader">
                <div slot="empty"><span v-if="!loading && shopList.length === 0">暂无数据</span></div>
                <el-table-column prop="WangWang" label="旺旺" align="center" header-align="center" width="118" />
                <el-table-column prop="CompanyName" label="公司名称" align="center" header-align="center" width="198" />
                <el-table-column align="center" header-align="center" label="店铺地址">
                    <template #default="{ row }">
                        <a :href="row.ShopUrl" target="_blank" style="color: #0064c1">{{ row.ShopUrl }}</a>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="操作" width="165">
                    <template #default="{ row }">
                        <el-button type="primary" size="small" @click="selectShop(row)">选择</el-button>
                        <el-link v-if="row.showDelBtn" style="margin-left: 20px" type="info" @click="deleteShop(row)"
                            >删除</el-link
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="text-align: center; padding: 10px 0"
                background
                :current-page="query.index"
                :page-size="query.size"
                layout="prev, pager, next, total, jumper"
                :total="query.total"
                @current-change="handleCurrentChange"
            />
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'OtherShop',
    data() {
        return {
            loading: false,
            visible: false,
            keyword: '',
            query: {
                index: 1,
                size: 6,
                total: 0,
            },
            shopList: [],
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            },
        };
    },
    computed: {
        account() {
            return this.$store.state.info?.memberInfo?.Account ?? '';
        },
    },
    methods: {
        show() {
            this.visible = true;
            this.getShopList();
        },
        addShop() {
            if (this.keyword === '') {
                this.$message.warning('请输入竞争对手店铺内任意一条产品地址或旺旺ID！');
                return;
            }
            this.loading = true;
            this.$ajax
                .post('app/ca/saveShop', {
                    keyword: this.keyword,
                })
                .then((res) => {
                    this.loading = false;
                    if (!res.Success) {
                        this.$message.warning(res.Message);
                        return;
                    }
                    this.$message.success('添加成功!');
                    this.getShopList();
                });
        },
        getShopList() {
            this.loading = true;
            this.$ajax
                .post('app/ca/getShopJSON', {
                    pageIndex: this.query.index,
                })
                .then((res) => {
                    this.loading = false;
                    if (!res.Success) {
                        this.$message.warning(res.Message);
                        return;
                    }
                    const len = res.Data.length;
                    if (res.Data && len) {
                        for (let i = 0; i < len; i++) {
                            res.Data[i].showDelBtn = this.account !== res.Data[i].WangWang;
                        }
                        this.query.total = res.TotalCount;
                        this.shopList = res.Data;
                    } else {
                        this.shopList = [];
                    }
                });
        },
        handleCurrentChange(index) {
            this.query.index = index;
            this.getShopList();
        },
        selectShop(row) {
            this.$emit('getShop', row);
            this.shopList = [];
            this.keyword = '';
            this.visible = false;
        },
        deleteShop(row) {
            this.$confirm('确定删除该店铺记录吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.$ajax
                        .post('app/ca/delShop', {
                            id: row.Id,
                        })
                        .then((res) => {
                            if (res.Success) {
                                this.$message.success(res.Message);
                                if (this.query.index !== 1 && this.shopList.length === 1) {
                                    this.query.index -= 1;
                                }
                                this.getShopList();
                            }
                        });
                })
                .catch(() => {});
        },
        handleClose(done) {
            this.shopList = [];
            this.keyword = '';
            done();
        },
    },
};
</script>
